<template>
  <div>
    <a role="button" class="btn btn-primary dbutton" @click="execSetting" v-if="!isSettingEnable">設定</a>
    <a role="button" class="btn btn-primary dbutton" @click="execSave" v-if="isSettingEnable">儲存</a>
    <a role="button" class="btn btn-danger dbutton" @click="execSetting" v-if="isSettingEnable">取消</a>

<!--    <a role="button" class="btn btn-primary" @click="btnTest">>Test</a>-->
<!--    <FileUploadButton></FileUploadButton>-->

    <h1>上方選單</h1>
    <ListCatalog :datas="datas.MenuTop" :is-setting-enable="isSettingEnable" bg-color="#2bac56"></ListCatalog>
    <hr>

    <h1>左側選單</h1>
    <ListCatalog :datas="datas.MenuLeft" :is-setting-enable="isSettingEnable" bg-color="#6cb2eb"></ListCatalog>


  </div>
</template>

<script>
/**

 **/
import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import ListCatalog from "./component/ListCatalog";
import {
  QueryType_Index_1_BannerImage,
  QueryType_Index_2_Team,
  QueryType_Index_3_Op,
  QueryType_Index_4_Action, QueryType_Index_5_3482, QueryType_Index_6_Images, QueryType_Index_7_Videos, QueryType_Menu
} from "./js/rotaryDeclare";



export default {
  components: {ListCatalog, FileUploadButton},
  //name: "conentCatalog",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      isSettingEnable:false,
      datasDemo:{
        MenuTop: {
          Items: [
            {
              SystemId: "3d843a91-af9f-437d-b187-e177166afa30",
              OrderKey: "",
              Text: "建成扶輪社",
              SubItems: [
                {
                  SystemId: "eefb09d2-5c06-4b1c-99a8-a2aa804995c3",
                  OrderKey: "",
                  Text: "關於建成",
                  LayoutType: "",
                },
                {
                  SystemId: "d219953e-0f2c-4f51-9776-1c0b3fed452a",
                  OrderKey: "",
                  Text: "年度營運",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "9e1ad094-b5bb-42c1-a83b-4779306932cb",
              OrderKey: "",
              Text: "家族扶輪社",
              SubItems: [
                {
                  SystemId: "6692f9f8-0d9d-4fcb-9417-0fcf11d76957",
                  OrderKey: "",
                  Text: "金蘭扶輪社",
                  LayoutType: "",
                },
                {
                  SystemId: "660b8757-a076-4d9f-92a1-2086641b857d",
                  OrderKey: "",
                  Text: "仙台扶輪社",
                  LayoutType: "",
                },
                {
                  SystemId: "7a29d132-3d1d-4f10-8077-7e5c46797fa2",
                  OrderKey: "",
                  Text: "名古屋扶輪社",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "5bdc749d-d837-4e26-a2b7-cd814572576a",
              OrderKey: "",
              Text: "3482地區",
              SubItems: [
                {
                  SystemId: "e5144936-c53f-4be0-82ff-68bef8ccb589",
                  OrderKey: "",
                  Text: "關於3482",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "a06fc21a-da54-4ebd-a864-85fe2454b83a",
              OrderKey: "",
              Text: "國際扶輪",
              SubItems: [
                {
                  SystemId: "610d3739-8c10-4647-8db9-af621e0afef0",
                  OrderKey: "",
                  Text: "關於國際扶輪",
                  LayoutType: "",
                },
                {
                  SystemId: "b5712b06-1bcd-41e4-a9c8-e52d6227e173",
                  OrderKey: "",
                  Text: "扶輪社中央系",
                  LayoutType: "",
                },
                {
                  SystemId: "93a6007d-3156-4d0c-ac05-1bb58e6d71fa",
                  OrderKey: "",
                  Text: "學習中心",
                  LayoutType: "",
                },
                {
                  SystemId: "29fface9-bb91-4c20-aad4-d747a441469c",
                  OrderKey: "",
                  Text: "品牌中心",
                  LayoutType: "",
                },
              ]
            },
          ],
        },
        MenuLeft: {
          Items: [
            {
              SystemId: "bac1b67a-4f79-42b8-8d1d-2fd5cef9e9b6",
              OrderKey: "",
              Text: "社會服務",
              SubItems: [
                {
                  SystemId: "b6b45be0-3c8b-4e2a-a4a1-78a9a8c73adf",
                  OrderKey: "",
                  Text: "每週例會",
                  LayoutType: "",
                },
                {
                  SystemId: "a36eb387-36f4-46b6-9e1d-6460eb756f5f",
                  OrderKey: "",
                  Text: "例會演講資料",
                  LayoutType: "",
                },
                {
                  SystemId: "ea77207b-d441-43a8-befe-241f82d63caf",
                  OrderKey: "",
                  Text: "高爾夫球隊",
                  LayoutType: "",
                },
                {
                  SystemId: "a6fe43ea-f438-42d2-a43d-79bfb4eca6c6",
                  OrderKey: "",
                  Text: "登山隊",
                  LayoutType: "",
                },
                {
                  SystemId: "8c8cab11-3277-4642-bf65-45a5249dd201",
                  OrderKey: "",
                  Text: "重訓保健隊",
                  LayoutType: "",
                },
                {
                  SystemId: "f11a1b1f-c3f3-44ce-be6f-ce834754a3c8",
                  OrderKey: "",
                  Text: "內輪會",
                  LayoutType: "",
                },
                {
                  SystemId: "f5ebdf8f-4373-4c35-a6fd-45a316b24edf",
                  OrderKey: "",
                  Text: "就職典禮",
                  LayoutType: "",
                },
                {
                  SystemId: "1e8683d3-8268-46d6-8e36-2d251dd1b18f",
                  OrderKey: "",
                  Text: "中秋晚會",
                  LayoutType: "",
                },
                {
                  SystemId: "dbbb6fe0-30a2-4ede-a35d-2de0e6f85dd7",
                  OrderKey: "",
                  Text: "年終晚會",
                  LayoutType: "",
                },
                {
                  SystemId: "7dfbc806-eefb-4414-873b-0ce0a52f723c",
                  OrderKey: "",
                  Text: "授證典禮",
                  LayoutType: "",
                },
                {
                  SystemId: "6dbe35d4-d1fc-44c9-b05f-4308c18a5c2f",
                  OrderKey: "",
                  Text: "金蘭社聯誼",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "beb07a77-6826-46d3-9919-902b8c08a7f6",
              OrderKey: "",
              Text: "社區服務",
              SubItems: [
                {
                  SystemId: "a1bec8c1-7a71-4679-aa22-614aa4436166",
                  OrderKey: "",
                  Text: "台文獎學金",
                  LayoutType: "",
                },
                {
                  SystemId: "a272d0b6-868e-41eb-b623-4cbd25bc0152",
                  OrderKey: "",
                  Text: "大內高手贊助",
                  LayoutType: "",
                },
                {
                  SystemId: "67c80180-367b-476c-958a-e3e366fbd293",
                  OrderKey: "",
                  Text: "好心肝贊助",
                  LayoutType: "",
                },
                {
                  SystemId: "99ad347f-7cd5-40d2-aef7-8ab721d7657c",
                  OrderKey: "",
                  Text: "社區服務集錦",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "c1c24747-949b-458a-b4cd-9ec619909e40",
              OrderKey: "",
              Text: "國際服務",
              SubItems: [
                {
                  SystemId: "307755b4-a4ce-497d-8380-cf887090d1f4",
                  OrderKey: "",
                  Text: "名古屋扶輪社",
                  LayoutType: "",
                },
                {
                  SystemId: "334a15a1-ec0a-4af4-a86a-2edc49f41d79",
                  OrderKey: "",
                  Text: "仙台扶輪社",
                  LayoutType: "",
                },
                {
                  SystemId: "270e6eb5-f95e-4b91-94dd-0fba878c8565",
                  OrderKey: "",
                  Text: "扶輪基金專案",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "5c389100-fef2-470c-891e-d18ec89b2fcd",
              OrderKey: "",
              Text: "職業服務",
              SubItems: [
                {
                  SystemId: "2eb3eb43-75cd-4611-b562-7e54e818754c",
                  OrderKey: "",
                  Text: "職業服務",
                  LayoutType: "",
                },
              ]
            },
            {
              SystemId: "acfdc279-02c5-4957-a48b-a937e469df6c",
              OrderKey: "",
              Text: "青少年服務",
              SubItems: [
                {
                  SystemId: "1e2556b0-f3bb-4a0e-a452-89c94a494b71",
                  OrderKey: "",
                  Text: "青少年服務",
                  LayoutType: "",
                },
              ]
            },
          ]
        },
      },
      webContent:{
        Menu:{
          Items:[
            {
              SystemId:"",
              OrderKey:"",
              Text:"",
              SubItems:[
                {
                  SystemId:"",
                  OrderKey:"",
                  Text:"",
                  LayoutType:"",
                },
              ]
            }
          ]
        },
        layoutA:{
          HtmlContent01:"",
          HtmlContent02:"",
          HtmlContent03:"",
          Items:[
            {
              SystemId:"",
              Date:"",
              Desc:"",
              Memo:"",
              HtmlContent01:"",
              HtmlContent02:"",
              HtmlContent03:"",
              CloudDownloadUrl:"",
              Images:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ],
              Videos:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ],
              AttachFiles:[
                {
                  SystemId:"",
                  Url:"",
                  OrderKey:"",
                  Desc:"",
                }
              ]
            }
          ]
        },
        IndexPage:[
          {
            SystemId:"",
            OrderKey:"",
            Text:"",
            Images:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ],
            TextLists:[
              {
                SystemId:"",
                OrderKey:"",
                IsEnable:"",
                Date:"",
                Desc:"",
              }
            ],
            Videos:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ],
            AttachFiles:[
              {
                SystemId:"",
                Url:"",
                OrderKey:"",
                Desc:"",
              }
            ]
          }
        ],
        YearsPage:{

        }
      },
      QueryType_Index_1_BannerImage:QueryType_Index_1_BannerImage,
      QueryType_Index_2_Team:QueryType_Index_2_Team,
      QueryType_Index_3_Op:QueryType_Index_3_Op,
      QueryType_Index_4_Action:QueryType_Index_4_Action,
      QueryType_Index_5_3482:QueryType_Index_5_3482,
      QueryType_Index_6_Images:QueryType_Index_6_Images,
      QueryType_Index_7_Videos:QueryType_Index_7_Videos,

      QueryType_Menu:QueryType_Menu,
    };
  },
  methods: {
    loadData() {
      apiAdmin.api_getContent(this.QueryType_Menu).then((data)=>{
        this.datas=apiAdmin.init(data.data.data);
      })
    },
    gotoMenu(item){
      this.$router.push({
        path: "/contentEdit",
        // path: item.url,
      });
    },
    execSetting(){
      this.isSettingEnable=!this.isSettingEnable;
    },
    execSave(){
      apiAdmin.api_saveContent(this.QueryType_Menu,this.datas).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.Id,this.datas2,"Id","OrderKey")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.Id,this.datas2,"Id","OrderKey")
    },
    DataItem_AddLast(){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderAppendLast(newItem,this.datas2,"OrderKey")
    },
    DataItem_Insert(currentItem){
      let newItem={
        Id:util.uuid(),
        Year:0,
        Moneth:0,
        Type:"",
        Rate:0,
        OrderKey:0,
      }

      arrayUtil.orderInsert(newItem,currentItem,this.datas2,"Id","OrderKey")
    },
    DataItem_Remove(item){
      //this.datas2= this.exchangeRatesDemo.filter(s => s.Id !==item.Id);
    },
    btnTest(){

      let data = {
        data:"testV"
      };

      apiAdmin.api_Upload(data).then((data)=>{
        console.log(data);
      });
      // apiAdmin.api_Test(data).then((data)=>{
      //   debugger // eslint-disable-line
      //   console.log(data);
      // });
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
.abutton{
  color: white;
  width: 100%;
  margin-bottom: 10px;
}
.cbutton{
  background-color: #1b9e3e;
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}

.dbutton{
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}
.topButton{
  background-color: #2bac56;
}
.leftButton{
  background-color: #6cb2eb;
}
</style>
